import React, { useState } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import CenterContainer from "../../../special/wholeSite/centerContainer";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

//STYLES
import * as mainMenuStyles from "../styles/mainMenu";

function MainMenu() {
    const navigate = useNavigate();
    const user = useSelector((state) => state.user);

    const [modal, setModal] = useState({
        header: "",
        open: false,
        message: ""
    });

    function handleCloseModal() {
        setModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    function handleOnlinePaymentsClick() {
        navigate("./onlinePayments");
    }

    function handleHelpDeskClick() {
        if (user.type == "seniorAdmin") {
            setModal({ header: "ViewHelp Online Helpdesk", message: "A Senior admin can't use the fornt end of the helpdesk", open: true });
        } else {
            navigate("./helpDesk");
        }
    }

    function handleCallOutClick() {
        navigate("./callOut");
    }

    return (
        <div>
            <Row>
                <Col>
                    <CenterContainer>
                        <div style={mainMenuStyles.topButtons} onClick={handleOnlinePaymentsClick}>
                            <span style={mainMenuStyles.topButtonsText}>
                                Online
                                <br />
                                Payments
                            </span>
                        </div>
                    </CenterContainer>
                </Col>
                <Col>
                    <CenterContainer>
                        <div style={mainMenuStyles.topButtons} onClick={handleHelpDeskClick}>
                            <span style={mainMenuStyles.topButtonsText}>
                                VeiwHelp
                                <br />
                                Online Helpdesk
                            </span>
                        </div>
                    </CenterContainer>
                </Col>
            </Row>
            <Row>
                <Col>
                    <CenterContainer ends={4} middle={4}>
                        <div style={mainMenuStyles.callOutButton} onClick={handleCallOutClick}>
                            Call Out High-View Studios
                        </div>
                    </CenterContainer>
                </Col>
            </Row>
            <Modal show={modal.open} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default MainMenu;
